/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

import { Injectable } from '@angular/core';
import {
  Route,
  UrlSegment,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { NavbarService } from '@root/shared/services/navbar.service';
import { SHARED_CONSTANTS } from '@root/shared/constants/shared-constants.constants';

export interface CanComponentLoad {
  canLoad(route?: Route, segments?: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class LoadAuthenticationGuardService {
  constructor(
    private navBarService: NavbarService,
    private router: Router
  ) {}
  public canLoad(route: Route): boolean {
    return this.checkAuthenticated(route);
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkAuthenticated(null, route, state);
  }

  private checkAuthenticated(
    route?: Route,
    routeSnapshot?: ActivatedRouteSnapshot,
    state?: RouterStateSnapshot
  ): boolean {
    if (this.navBarService.isLoggedIn()) {
      return true;
    }
    const routePath = route && route.path ? '/' + route.path : '';
    const pathParams = {
      path: state && state.url ? state.url : routePath,
      lang: '',
    };
    this.router.navigate([SHARED_CONSTANTS.AUTH, pathParams]);
    return false;
  }
}
